var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.11 14.836c0-.393.073-.77.206-1.118L6.89 11.6a3.742 3.742 0 0 1-2.647 1.09C2.183 12.692.51 11.036.51 9c0-2.036 1.674-3.691 3.733-3.691a3.74 3.74 0 0 1 2.61 1.053l3.446-2.129a3.112 3.112 0 0 1-.188-1.07C10.11 1.42 11.545 0 13.31 0c1.765 0 3.2 1.42 3.2 3.164 0 1.745-1.435 3.166-3.2 3.166-.709 0-1.366-.23-1.897-.618L7.817 7.933a3.62 3.62 0 0 1 .015 2.084l3.625 2.24a3.211 3.211 0 0 1 1.853-.585c1.765 0 3.2 1.42 3.2 3.164 0 1.745-1.435 3.164-3.2 3.164-1.765 0-3.2-1.419-3.2-3.164z",
    fill: "#F6B119",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareOrange);
export default __webpack_public_path__ + "static/media/share-orange.3f59e45b0b832c4733facad5ed60f044.svg";
export { ForwardRef as ReactComponent };